import ClassNames from "classnames";
import * as React from "react";
import Checkmark from "../_assets/icon-checkmark.svg";
import Styles from "./Checkbox.module.css";

import InputLabel from "../InputLabel";
import Typography from "../Typography";

export interface Props {
  value?: string;
  className?: string;
  optionLabel: string;
  name?: string;
  errors?: string[];
  id: string;
  disabled?: boolean;
  checked?: boolean;
  helperText?: string;
  checkTile?: boolean;
  inline?: boolean;
  required?: boolean;
  nativeRequired?: boolean;
  inputRef?: any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<Props> = props => {
  const {
    className,
    optionLabel,
    name,
    value,
    errors,
    id,
    disabled,
    checked,
    helperText,
    required,
    nativeRequired,
    inputRef,
    checkTile,
    inline,
    onChange
  } = props;

  return (
    <>
      <div
        className={ClassNames({
          [Styles.wrapper]: true,
          [Styles.checkTile]: checkTile,
          [Styles.inline]: inline,
          [className]: className
        })}
        role="group"
      >
        <input
          type="checkbox"
          className="sr-only"
          name={name}
          value={value}
          id={id}
          disabled={disabled ? disabled : undefined}
          checked={checked}
          onChange={onChange}
          required={nativeRequired}
          ref={inputRef}
        />
        <span className={Styles.checkbox} />
        {checked && (
          <span className={Styles.checkmarkIcon}>
            <Checkmark />
          </span>
        )}
        <InputLabel
          label={optionLabel}
          htmlFor={id}
          required={required}
          nativeRequired={nativeRequired}
          className={Styles.label}
        />
        {helperText && (
          <Typography body="small" className={Styles.helper}>
            {helperText}
          </Typography>
        )}
        {errors &&
          errors.map((error, i) => {
            return (
              <Typography
                body="small"
                className={ClassNames({
                  [Styles.error]: true,
                  [Styles.firstError]: errors.length !== 1 && i === 0
                })}
                key={`error-${id}-${i}`}
              >
                {error}
              </Typography>
            );
          })}
      </div>
    </>
  );
};

export default Checkbox;
